module.exports = __webpack_public_path__ + "static/divas7-4b14ddd975ee4e2112ca42ef4b9bc189.jpg";